export default class Faq {
  constructor() {
    this.setVars()
  }
  
  setVars() {
    this.settings = {
      init: 'data-faq',
      item: 'data-faq-item',
      button: 'data-faq-button',
      search_wrapper: 'data-faq-search',
      search_input: 'data-faq-search-input',
      search_button: 'data-faq-search-button',
    };
    
    this.faqs = document.querySelectorAll(`[${this.settings.init}]`);
    if (!this.faqs) return false;
    
    this.faq_search = document.querySelector(`[${this.settings.search_wrapper}]`);
    
    this.setEvents();
  }
  
  setEvents() {
    
    if (this.faqs) {
      this.faqs.forEach(faq => {
        faq.querySelectorAll(`[${this.settings.item}]`).forEach(item => {
          const button = item.querySelectorAll(`[${this.settings.button}]`);
          button.forEach(singleButton => {
            singleButton.addEventListener('click', () => {
              button.toggleClass('collapsed')
              item.toggleClass('open')
            })
          })
        })
      })
    }
    
    if (this.faq_search) {
  
      this.faq_search.addEventListener('submit', (e) => {
        e.stopPropagation();
        e.preventDefault();
  
        const search_input = this.faq_search.querySelector('input[type="text"]').value;
  
        this.faqs.forEach(faq => {
          faq.querySelectorAll(`[${this.settings.item}]`).forEach(item => {
            item.removeClass('hide');
            const attribute = item.getAttribute(`${this.settings.item}`).toLowerCase();
            
            if (attribute.indexOf(search_input.toLowerCase()) === -1) {
              item.addClass('hide');
            }
          });
        });
      });
    }
  }
}
